var _defs, _rect, _rect2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "85fe2da4aa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 635,
    y: 0,
    height: 87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74bf5a7795"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 401.125 139.871094 L 408.875 139.871094 L 408.875 170.125 L 401.125 170.125 Z M 401.125 139.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e97f9cccfc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 405 139.871094 C 406.027344 139.871094 407.015625 140.28125 407.742188 141.007812 C 408.46875 141.734375 408.875 142.71875 408.875 143.75 L 408.875 166.234375 C 408.875 167.265625 408.46875 168.25 407.742188 168.976562 C 407.015625 169.703125 406.027344 170.113281 405 170.113281 C 403.972656 170.113281 402.984375 169.703125 402.257812 168.976562 C 401.53125 168.25 401.125 167.265625 401.125 166.234375 L 401.125 143.75 C 401.125 142.71875 401.53125 141.734375 402.257812 141.007812 C 402.984375 140.28125 403.972656 139.871094 405 139.871094 Z M 405 139.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "80788ecf13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.125 0.871094 L 7.875 0.871094 L 7.875 31.113281 L 0.125 31.113281 Z M 0.125 0.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "195f1f997d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 0.871094 C 5.027344 0.871094 6.015625 1.28125 6.742188 2.007812 C 7.46875 2.734375 7.875 3.71875 7.875 4.75 L 7.875 27.234375 C 7.875 28.265625 7.46875 29.25 6.742188 29.976562 C 6.015625 30.703125 5.027344 31.113281 4 31.113281 C 2.972656 31.113281 1.984375 30.703125 1.257812 29.976562 C 0.53125 29.25 0.125 28.265625 0.125 27.234375 L 0.125 4.75 C 0.125 3.71875 0.53125 2.734375 1.257812 2.007812 C 1.984375 1.28125 2.972656 0.871094 4 0.871094 Z M 4 0.871094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.00000776669,
    gradientTransform: "matrix(0.0302832, 0.000000000000000008, -0.000000000000000008, 0.0302832, 0.123743, 0.871849)",
    y1: 499.28799,
    x2: 255.999721,
    gradientUnits: "userSpaceOnUse",
    y2: 499.28799,
    id: "b951779ffe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.327759%, 58.691406%, 92.799377%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.205688%, 58.436584%, 92.520142%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.082092%, 58.183289%, 92.240906%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.960022%, 57.928467%, 91.963196%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.837952%, 57.673645%, 91.68396%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.715881%, 57.420349%, 91.404724%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.592285%, 57.165527%, 91.127014%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.470215%, 56.912231%, 90.847778%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.348145%, 56.65741%, 90.568542%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.224548%, 56.402588%, 90.289307%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 56.149292%, 90.011597%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.980408%, 55.89447%, 89.732361%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.858337%, 55.639648%, 89.453125%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 55.386353%, 89.173889%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.612671%, 55.131531%, 88.896179%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.490601%, 54.876709%, 88.616943%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.36853%, 54.623413%, 88.337708%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.244934%, 54.368591%, 88.058472%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.122864%, 54.11377%, 87.780762%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.000793%, 53.860474%, 87.501526%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.877197%, 53.605652%, 87.22229%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.755127%, 53.35083%, 86.94458%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.633057%, 53.097534%, 86.665344%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 52.842712%, 86.386108%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.38739%, 52.587891%, 86.106873%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.26532%, 52.334595%, 85.829163%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 52.079773%, 85.549927%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.019653%, 51.824951%, 85.270691%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.897583%, 51.571655%, 84.991455%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.775513%, 51.316833%, 84.713745%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 51.062012%, 84.434509%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.529846%, 50.808716%, 84.155273%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.407776%, 50.553894%, 83.876038%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.285706%, 50.299072%, 83.598328%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.162109%, 50.045776%, 83.319092%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.040039%, 49.790955%, 83.039856%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.917969%, 49.537659%, 82.762146%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.795898%, 49.282837%, 82.48291%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.672302%, 49.028015%, 82.203674%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.774719%, 81.924438%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.428162%, 48.519897%, 81.646729%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.304565%, 48.265076%, 81.367493%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.182495%, 48.01178%, 81.088257%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 47.756958%, 80.809021%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.938354%, 47.502136%, 80.531311%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 47.24884%, 80.252075%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.692688%, 46.994019%, 79.972839%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.570618%, 46.739197%, 79.693604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.447021%, 46.485901%, 79.415894%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.324951%, 46.231079%, 79.136658%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.202881%, 45.976257%, 78.857422%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.080811%, 45.722961%, 78.579712%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.957214%, 45.46814%, 78.300476%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.835144%, 45.213318%, 78.02124%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.713074%, 44.960022%, 77.742004%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 44.7052%, 77.464294%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.467407%, 44.450378%, 77.185059%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.345337%, 44.197083%, 76.905823%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.223267%, 43.942261%, 76.626587%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.09967%, 43.687439%, 76.348877%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.9776%, 43.434143%, 76.069641%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.85553%, 43.179321%, 75.790405%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.733459%, 42.9245%, 75.512695%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.609863%, 42.671204%, 75.233459%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.487793%, 42.416382%, 74.954224%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.365723%, 42.16156%, 74.674988%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.242126%, 41.908264%, 74.397278%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.120056%, 41.653442%, 74.118042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.997986%, 41.400146%, 73.838806%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.875916%, 41.145325%, 73.55957%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.752319%, 40.890503%, 73.28186%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.630249%, 40.637207%, 73.002625%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.382385%, 72.723389%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 40.127563%, 72.444153%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.262512%, 39.874268%, 72.166443%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.140442%, 39.619446%, 71.887207%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.018372%, 39.364624%, 71.607971%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.894775%, 39.111328%, 71.330261%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.772705%, 38.856506%, 71.051025%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.650635%, 38.601685%, 70.77179%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.527039%, 38.348389%, 70.492554%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.404968%, 38.093567%, 70.214844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.282898%, 37.838745%, 69.935608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.160828%, 37.585449%, 69.656372%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.037231%, 37.330627%, 69.377136%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.915161%, 37.075806%, 69.099426%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.793091%, 36.82251%, 68.82019%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.671021%, 36.567688%, 68.540955%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.312866%, 68.261719%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.425354%, 36.05957%, 67.984009%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.303284%, 35.804749%, 67.704773%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.179688%, 35.549927%, 67.425537%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.057617%, 35.296631%, 67.147827%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.935547%, 35.041809%, 66.868591%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.786987%, 66.589355%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.68988%, 34.533691%, 66.31012%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 34.27887%, 66.03241%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.44574%, 34.025574%, 65.753174%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.322144%, 33.770752%, 65.473938%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.200073%, 33.51593%, 65.194702%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.078003%, 33.262634%, 64.916992%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.955933%, 33.007812%, 64.637756%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.832336%, 32.752991%, 64.358521%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.710266%, 32.499695%, 64.079285%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.588196%, 32.244873%, 63.801575%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.4646%, 31.990051%, 63.522339%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.342529%, 31.736755%, 63.243103%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.220459%, 31.481934%, 62.965393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.098389%, 31.227112%, 62.686157%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.974792%, 30.973816%, 62.406921%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.852722%, 30.718994%, 62.127686%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.730652%, 30.464172%, 61.849976%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.607056%, 30.210876%, 61.57074%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.484985%, 29.956055%, 61.291504%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.362915%, 29.701233%, 61.012268%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 29.447937%, 60.734558%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.117249%, 29.193115%, 60.455322%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.995178%, 28.938293%, 60.176086%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.873108%, 28.684998%, 59.896851%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.751038%, 28.430176%, 59.619141%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.627441%, 28.175354%, 59.339905%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.505371%, 27.922058%, 59.060669%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.383301%, 27.667236%, 58.782959%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.259705%, 27.412415%, 58.503723%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.137634%, 27.159119%, 58.224487%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 26.904297%, 57.945251%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.893494%, 26.649475%, 57.667542%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.769897%, 26.396179%, 57.388306%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8852956c6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 8,
    y: 0,
    height: 32
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd476f986b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 329.332031 363.5625 L 372.667969 363.5625 L 372.667969 560.449219 L 329.332031 560.449219 Z M 329.332031 363.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "983c23e251"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 351 363.5625 C 362.96875 363.5625 372.667969 373.265625 372.667969 385.234375 L 372.667969 538.714844 C 372.667969 550.683594 362.96875 560.386719 351 560.386719 C 339.03125 560.386719 329.332031 550.683594 329.332031 538.714844 L 329.332031 385.234375 C 329.332031 373.265625 339.03125 363.5625 351 363.5625 Z M 351 363.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c9f7b209a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.332031 0.5625 L 43.667969 0.5625 L 43.667969 197.386719 L 0.332031 197.386719 Z M 0.332031 0.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "487d66dc5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22 0.5625 C 33.96875 0.5625 43.667969 10.265625 43.667969 22.234375 L 43.667969 175.714844 C 43.667969 187.683594 33.96875 197.386719 22 197.386719 C 10.03125 197.386719 0.332031 187.683594 0.332031 175.714844 L 0.332031 22.234375 C 0.332031 10.265625 10.03125 0.5625 22 0.5625 Z M 22 0.5625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1.13414e-7,
    gradientTransform: "matrix(0.169291, 0, 0, 0.169291, 0.330785, 0.56297)",
    y1: 581.315,
    x2: 255.999955,
    gradientUnits: "userSpaceOnUse",
    y2: 581.315,
    id: "f0d7f98cec"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.327759%, 58.691406%, 92.799377%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.205688%, 58.436584%, 92.520142%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.082092%, 58.183289%, 92.240906%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.960022%, 57.928467%, 91.963196%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.837952%, 57.673645%, 91.68396%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.715881%, 57.420349%, 91.404724%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.592285%, 57.165527%, 91.127014%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.470215%, 56.912231%, 90.847778%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.348145%, 56.65741%, 90.568542%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.224548%, 56.402588%, 90.289307%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 56.149292%, 90.011597%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.980408%, 55.89447%, 89.732361%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.858337%, 55.639648%, 89.453125%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 55.386353%, 89.173889%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.612671%, 55.131531%, 88.896179%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.490601%, 54.876709%, 88.616943%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.36853%, 54.623413%, 88.337708%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.244934%, 54.368591%, 88.058472%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.122864%, 54.11377%, 87.780762%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.000793%, 53.860474%, 87.501526%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.877197%, 53.605652%, 87.22229%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.755127%, 53.35083%, 86.94458%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.633057%, 53.097534%, 86.665344%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 52.842712%, 86.386108%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.38739%, 52.587891%, 86.106873%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.26532%, 52.334595%, 85.829163%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 52.079773%, 85.549927%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.019653%, 51.824951%, 85.270691%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.897583%, 51.571655%, 84.991455%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.775513%, 51.316833%, 84.713745%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 51.062012%, 84.434509%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.529846%, 50.808716%, 84.155273%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.407776%, 50.553894%, 83.876038%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.285706%, 50.299072%, 83.598328%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.162109%, 50.045776%, 83.319092%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.040039%, 49.790955%, 83.039856%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.917969%, 49.537659%, 82.762146%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.795898%, 49.282837%, 82.48291%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.672302%, 49.028015%, 82.203674%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.774719%, 81.924438%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.428162%, 48.519897%, 81.646729%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.304565%, 48.265076%, 81.367493%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.182495%, 48.01178%, 81.088257%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 47.756958%, 80.809021%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.938354%, 47.502136%, 80.531311%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 47.24884%, 80.252075%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.692688%, 46.994019%, 79.972839%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.570618%, 46.739197%, 79.693604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.447021%, 46.485901%, 79.415894%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.324951%, 46.231079%, 79.136658%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.202881%, 45.976257%, 78.857422%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.080811%, 45.722961%, 78.579712%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.957214%, 45.46814%, 78.300476%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.835144%, 45.213318%, 78.02124%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.713074%, 44.960022%, 77.742004%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 44.7052%, 77.464294%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.467407%, 44.450378%, 77.185059%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.345337%, 44.197083%, 76.905823%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.223267%, 43.942261%, 76.626587%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.09967%, 43.687439%, 76.348877%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.9776%, 43.434143%, 76.069641%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.85553%, 43.179321%, 75.790405%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.733459%, 42.9245%, 75.511169%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.609863%, 42.671204%, 75.233459%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.487793%, 42.416382%, 74.954224%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.365723%, 42.16156%, 74.674988%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.242126%, 41.908264%, 74.397278%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.120056%, 41.653442%, 74.118042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.997986%, 41.400146%, 73.838806%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.875916%, 41.145325%, 73.55957%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.752319%, 40.890503%, 73.28186%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.630249%, 40.637207%, 73.002625%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.382385%, 72.723389%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 40.127563%, 72.444153%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.262512%, 39.874268%, 72.166443%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.140442%, 39.619446%, 71.887207%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.018372%, 39.364624%, 71.607971%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.894775%, 39.111328%, 71.330261%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.772705%, 38.856506%, 71.051025%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.650635%, 38.601685%, 70.77179%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.527039%, 38.348389%, 70.492554%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.404968%, 38.093567%, 70.214844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.282898%, 37.838745%, 69.935608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.160828%, 37.585449%, 69.656372%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.037231%, 37.330627%, 69.377136%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.915161%, 37.075806%, 69.099426%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.793091%, 36.82251%, 68.82019%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.671021%, 36.567688%, 68.540955%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.312866%, 68.261719%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.425354%, 36.05957%, 67.984009%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.303284%, 35.804749%, 67.704773%)",
    offset: 0.710937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.179688%, 35.549927%, 67.425537%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.057617%, 35.296631%, 67.147827%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.935547%, 35.041809%, 66.868591%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.786987%, 66.589355%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.68988%, 34.533691%, 66.31012%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 34.27887%, 66.03241%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.44574%, 34.024048%, 65.753174%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.322144%, 33.770752%, 65.473938%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.200073%, 33.51593%, 65.194702%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.078003%, 33.262634%, 64.916992%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.955933%, 33.007812%, 64.637756%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.832336%, 32.752991%, 64.358521%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.710266%, 32.499695%, 64.079285%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.588196%, 32.244873%, 63.801575%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.4646%, 31.990051%, 63.522339%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.342529%, 31.736755%, 63.243103%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.220459%, 31.481934%, 62.965393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.098389%, 31.227112%, 62.686157%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.974792%, 30.973816%, 62.406921%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.852722%, 30.718994%, 62.127686%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.730652%, 30.464172%, 61.849976%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.607056%, 30.210876%, 61.57074%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.484985%, 29.956055%, 61.291504%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.362915%, 29.701233%, 61.012268%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 29.447937%, 60.734558%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.117249%, 29.193115%, 60.455322%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.995178%, 28.938293%, 60.176086%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.873108%, 28.684998%, 59.896851%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.751038%, 28.430176%, 59.619141%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.627441%, 28.175354%, 59.339905%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.505371%, 27.922058%, 59.060669%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.383301%, 27.667236%, 58.782959%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.259705%, 27.412415%, 58.503723%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.137634%, 27.159119%, 58.224487%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 26.904297%, 57.945251%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.893494%, 26.649475%, 57.667542%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.769897%, 26.396179%, 57.388306%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d60e29ca45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 44,
    y: 0,
    height: 198
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5227c8171d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 372 250 L 494 250 L 494 327 L 372 327 Z M 372 250 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa0d651ce1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 483.734375 244.09375 L 500.183594 281.8125 L 382.609375 333.089844 L 366.160156 295.371094 Z M 483.734375 244.09375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aeee68e06b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 491.957031 262.953125 C 494.140625 267.953125 494.246094 273.617188 492.25 278.695312 C 490.257812 283.777344 486.328125 287.855469 481.324219 290.035156 L 401.515625 324.84375 C 396.515625 327.023438 390.851562 327.128906 385.773438 325.132812 C 380.691406 323.140625 376.613281 319.210938 374.433594 314.207031 C 372.25 309.207031 372.148438 303.542969 374.140625 298.464844 C 376.136719 293.386719 380.066406 289.304688 385.066406 287.125 L 464.875 252.320312 C 469.875 250.136719 475.539062 250.03125 480.621094 252.027344 C 485.699219 254.019531 489.777344 257.953125 491.957031 262.953125 Z M 491.957031 262.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cbf5a6eb66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 122 0 L 122 77 L 0 77 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4fa8f46064"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.734375 -5.90625 L 128.183594 31.8125 L 10.609375 83.089844 L -5.839844 45.371094 Z M 111.734375 -5.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a4fdaf9d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.957031 12.953125 C 122.140625 17.953125 122.246094 23.617188 120.25 28.695312 C 118.257812 33.777344 114.328125 37.855469 109.324219 40.035156 L 29.515625 74.84375 C 24.515625 77.023438 18.851562 77.128906 13.773438 75.132812 C 8.691406 73.140625 4.613281 69.210938 2.433594 64.207031 C 0.25 59.207031 0.148438 53.542969 2.140625 48.464844 C 4.136719 43.386719 8.066406 39.304688 13.066406 37.125 L 92.875 2.320312 C 97.875 0.136719 103.539062 0.03125 108.621094 2.027344 C 113.699219 4.019531 117.777344 7.953125 119.957031 12.953125 Z M 119.957031 12.953125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b4d603b7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.734375 -5.90625 L 128.183594 31.8125 L 10.609375 83.089844 L -5.839844 45.371094 Z M 111.734375 -5.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44195688a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111.734375 -5.90625 L 128.183594 31.8125 L 10.65625 83.066406 L -5.792969 45.347656 Z M 111.734375 -5.90625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -243.656897,
    gradientTransform: "matrix(0.0642562, 0.147335, -0.147335, 0.0642562, 111.734156, -5.90612)",
    y1: 398.83801,
    x2: 499.65697,
    gradientUnits: "userSpaceOnUse",
    y2: 398.83801,
    id: "5fb67b1be6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.381165%, 58.804321%, 92.921448%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.196533%, 58.4198%, 92.500305%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.018005%, 58.050537%, 92.095947%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.839478%, 57.681274%, 91.690063%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.662476%, 57.312012%, 91.285706%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.483948%, 56.942749%, 90.881348%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.306946%, 56.573486%, 90.47699%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.128418%, 56.204224%, 90.071106%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.951416%, 55.834961%, 89.666748%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.772888%, 55.465698%, 89.26239%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.595886%, 55.096436%, 88.858032%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.417358%, 54.727173%, 88.452148%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.240356%, 54.35791%, 88.047791%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.061829%, 53.988647%, 87.641907%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.884827%, 53.619385%, 87.237549%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.706299%, 53.250122%, 86.833191%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.529297%, 52.880859%, 86.428833%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.350769%, 52.511597%, 86.022949%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.173767%, 52.142334%, 85.618591%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.995239%, 51.773071%, 85.214233%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.818237%, 51.405334%, 84.809875%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.639709%, 51.036072%, 84.403992%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.461182%, 50.666809%, 83.999634%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.282654%, 50.297546%, 83.595276%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.105652%, 49.928284%, 83.190918%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.927124%, 49.559021%, 82.785034%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.750122%, 49.189758%, 82.380676%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.571594%, 48.820496%, 81.974792%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.394592%, 48.451233%, 81.570435%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.216064%, 48.08197%, 81.166077%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.039062%, 47.712708%, 80.761719%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.860535%, 47.343445%, 80.355835%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.683533%, 46.974182%, 79.951477%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.505005%, 46.604919%, 79.547119%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.328003%, 46.235657%, 79.142761%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.149475%, 45.866394%, 78.736877%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.972473%, 45.497131%, 78.33252%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.793945%, 45.127869%, 77.926636%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.616943%, 44.758606%, 77.522278%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.438416%, 44.389343%, 77.11792%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.259888%, 44.021606%, 76.713562%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.08136%, 43.652344%, 76.307678%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.904358%, 43.283081%, 75.90332%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.72583%, 42.913818%, 75.498962%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.548828%, 42.544556%, 75.094604%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.3703%, 42.175293%, 74.688721%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.193298%, 41.80603%, 74.284363%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.014771%, 41.436768%, 73.880005%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.837769%, 41.067505%, 73.475647%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.659241%, 40.698242%, 73.069763%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.482239%, 40.328979%, 72.665405%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.303711%, 39.959717%, 72.259521%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.126709%, 39.590454%, 71.855164%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.948181%, 39.221191%, 71.450806%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.771179%, 38.851929%, 71.046448%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.592651%, 38.482666%, 70.640564%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.415649%, 38.113403%, 70.236206%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.237122%, 37.744141%, 69.831848%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.06012%, 37.376404%, 69.42749%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.881592%, 37.007141%, 69.021606%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.703064%, 36.637878%, 68.617249%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.524536%, 36.268616%, 68.212891%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.347534%, 35.899353%, 67.808533%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.169006%, 35.53009%, 67.402649%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.992004%, 35.160828%, 66.998291%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.791565%, 66.592407%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.636475%, 34.422302%, 66.188049%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.457947%, 34.05304%, 65.783691%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.280945%, 33.683777%, 65.379333%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.102417%, 33.314514%, 64.97345%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.925415%, 32.945251%, 64.569092%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.746887%, 32.575989%, 64.164734%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.569885%, 32.206726%, 63.760376%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.391357%, 31.837463%, 63.354492%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.214355%, 31.468201%, 62.950134%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.035828%, 31.098938%, 62.545776%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.858826%, 30.729675%, 62.141418%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.680298%, 30.360413%, 61.735535%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.503296%, 29.992676%, 61.331177%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.324768%, 29.623413%, 60.925293%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.14624%, 29.25415%, 60.520935%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.967712%, 28.884888%, 60.116577%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.79071%, 28.515625%, 59.712219%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.612183%, 28.146362%, 59.306335%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.435181%, 27.7771%, 58.901978%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.256653%, 27.407837%, 58.49762%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.079651%, 27.038574%, 58.093262%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.901123%, 26.669312%, 57.687378%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.724121%, 26.300049%, 57.28302%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.716492%, 26.28479%, 57.266235%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.708862%, 26.269531%, 57.249451%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.708862%, 26.269531%, 57.249451%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "148dd309cc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 122,
    y: 0,
    height: 77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad5c6e4169"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 208 253 L 329 253 L 329 329 L 208 329 Z M 208 253 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab1c562f37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 334.824219 297.734375 L 318.394531 335.460938 L 201.679688 284.628906 L 218.109375 246.902344 Z M 334.824219 297.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8bd1843ce1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 326.609375 316.597656 C 324.429688 321.601562 320.351562 325.53125 315.273438 327.53125 C 310.195312 329.527344 304.535156 329.425781 299.53125 327.246094 L 220.660156 292.898438 C 215.660156 290.71875 211.726562 286.640625 209.730469 281.5625 C 207.730469 276.484375 207.835938 270.824219 210.011719 265.820312 C 212.191406 260.816406 216.269531 256.882812 221.347656 254.886719 C 226.425781 252.890625 232.089844 252.992188 237.089844 255.171875 L 315.960938 289.519531 C 320.964844 291.699219 324.894531 295.773438 326.894531 300.851562 C 328.890625 305.929688 328.789062 311.59375 326.609375 316.597656 Z M 326.609375 316.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f1bfee2dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 121 0 L 121 76 L 0 76 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "425ffdfd79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.824219 44.734375 L 110.394531 82.460938 L -6.320312 31.628906 L 10.109375 -6.097656 Z M 126.824219 44.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b962268f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 118.609375 63.597656 C 116.429688 68.601562 112.351562 72.53125 107.273438 74.53125 C 102.195312 76.527344 96.535156 76.425781 91.53125 74.246094 L 12.660156 39.898438 C 7.660156 37.71875 3.726562 33.640625 1.730469 28.5625 C -0.269531 23.484375 -0.164062 17.824219 2.011719 12.820312 C 4.191406 7.816406 8.269531 3.882812 13.347656 1.886719 C 18.425781 -0.109375 24.089844 -0.0078125 29.089844 2.171875 L 107.960938 36.519531 C 112.964844 38.699219 116.894531 42.773438 118.894531 47.851562 C 120.890625 52.929688 120.789062 58.59375 118.609375 63.597656 Z M 118.609375 63.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c8f69834d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.824219 44.734375 L 110.394531 82.460938 L -6.175781 31.695312 L 10.253906 -6.03125 Z M 126.824219 44.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "387cc681ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.824219 44.734375 L 110.394531 82.460938 L -6.199219 31.683594 L 10.230469 -6.042969 Z M 126.824219 44.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -241.041052,
    gradientTransform: "matrix(-0.064179, 0.147369, -0.147369, -0.064179, 126.824886, 44.734359)",
    y1: 395.59201,
    x2: 497.041216,
    gradientUnits: "userSpaceOnUse",
    y2: 395.59201,
    id: "95b5ecd7c8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.353699%, 58.746338%, 92.858887%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.141602%, 58.306885%, 92.376709%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.966125%, 57.940674%, 91.975403%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.789124%, 57.574463%, 91.574097%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.613647%, 57.208252%, 91.172791%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.436646%, 56.840515%, 90.769958%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.259644%, 56.474304%, 90.368652%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.082642%, 56.108093%, 89.96582%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.907166%, 55.741882%, 89.564514%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.730164%, 55.374146%, 89.161682%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.553162%, 55.007935%, 88.760376%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.37616%, 54.641724%, 88.357544%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.200684%, 54.275513%, 87.956238%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.023682%, 53.907776%, 87.553406%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.84668%, 53.541565%, 87.1521%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.669678%, 53.175354%, 86.750793%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.494202%, 52.809143%, 86.349487%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.3172%, 52.441406%, 85.946655%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.140198%, 52.075195%, 85.545349%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.963196%, 51.708984%, 85.142517%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.78772%, 51.342773%, 84.741211%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.610718%, 50.975037%, 84.338379%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.433716%, 50.608826%, 83.937073%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.256714%, 50.242615%, 83.534241%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.081238%, 49.876404%, 83.132935%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.904236%, 49.508667%, 82.730103%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.727234%, 49.142456%, 82.328796%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.776245%, 81.925964%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.374756%, 48.410034%, 81.524658%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.197754%, 48.042297%, 81.123352%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.022278%, 47.676086%, 80.722046%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.845276%, 47.309875%, 80.319214%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.668274%, 46.943665%, 79.917908%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.491272%, 46.575928%, 79.515076%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.315796%, 46.209717%, 79.11377%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.138794%, 45.843506%, 78.710938%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.961792%, 45.477295%, 78.309631%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.78479%, 45.109558%, 77.906799%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.609314%, 44.743347%, 77.505493%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.432312%, 44.377136%, 77.102661%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.25531%, 44.010925%, 76.701355%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.078308%, 43.643188%, 76.300049%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.902832%, 43.276978%, 75.898743%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.72583%, 42.910767%, 75.495911%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.548828%, 42.544556%, 75.094604%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.371826%, 42.176819%, 74.691772%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.19635%, 41.810608%, 74.290466%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.019348%, 41.444397%, 73.887634%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.842346%, 41.078186%, 73.486328%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.665344%, 40.710449%, 73.083496%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.489868%, 40.344238%, 72.68219%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.312866%, 39.978027%, 72.279358%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.135864%, 39.611816%, 71.878052%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.958862%, 39.24408%, 71.476746%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.783386%, 38.877869%, 71.075439%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.606384%, 38.511658%, 70.672607%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.429382%, 38.145447%, 70.271301%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.25238%, 37.77771%, 69.868469%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.076904%, 37.411499%, 69.467163%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.899902%, 37.045288%, 69.064331%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.724426%, 36.679077%, 68.663025%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.31134%, 68.260193%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.370422%, 35.945129%, 67.858887%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.19342%, 35.578918%, 67.456055%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.017944%, 35.212708%, 67.054749%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.840942%, 34.844971%, 66.651917%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.66394%, 34.47876%, 66.25061%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.486938%, 34.112549%, 65.849304%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.311462%, 33.746338%, 65.447998%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.13446%, 33.378601%, 65.045166%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.957458%, 33.01239%, 64.64386%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.780457%, 32.646179%, 64.241028%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.60498%, 32.279968%, 63.839722%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.427979%, 31.912231%, 63.43689%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.250977%, 31.546021%, 63.035583%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.073975%, 31.17981%, 62.632751%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.898499%, 30.813599%, 62.231445%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.721497%, 30.445862%, 61.828613%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.544495%, 30.079651%, 61.427307%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.367493%, 29.71344%, 61.026001%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.192017%, 29.347229%, 60.624695%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.015015%, 28.979492%, 60.221863%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.838013%, 28.613281%, 59.820557%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.661011%, 28.24707%, 59.417725%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.485535%, 27.880859%, 59.016418%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.308533%, 27.513123%, 58.613586%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.133057%, 27.146912%, 58.21228%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.956055%, 26.780701%, 57.809448%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.779053%, 26.41449%, 57.408142%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.743958%, 26.341248%, 57.328796%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.708862%, 26.269531%, 57.249451%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.708862%, 26.269531%, 57.249451%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea282670ae"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 121,
    y: 0,
    height: 76
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0abdf30515"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 312.308594 294.378906 L 389.683594 294.378906 L 389.683594 371.753906 L 312.308594 371.753906 Z M 312.308594 294.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a794e42c0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 389.683594 333.066406 C 389.683594 334.332031 389.625 335.597656 389.5 336.859375 C 389.375 338.121094 389.1875 339.371094 388.941406 340.613281 C 388.695312 341.855469 388.386719 343.085938 388.019531 344.296875 C 387.652344 345.507812 387.226562 346.699219 386.742188 347.871094 C 386.253906 349.042969 385.714844 350.1875 385.117188 351.304688 C 384.519531 352.421875 383.867188 353.507812 383.164062 354.558594 C 382.460938 355.613281 381.707031 356.628906 380.902344 357.609375 C 380.101562 358.589844 379.25 359.527344 378.355469 360.421875 C 377.457031 361.320312 376.519531 362.167969 375.539062 362.972656 C 374.5625 363.777344 373.542969 364.53125 372.492188 365.234375 C 371.4375 365.9375 370.351562 366.589844 369.234375 367.1875 C 368.117188 367.78125 366.972656 368.324219 365.800781 368.808594 C 364.632812 369.292969 363.441406 369.71875 362.226562 370.089844 C 361.015625 370.457031 359.789062 370.761719 358.546875 371.011719 C 357.300781 371.257812 356.050781 371.445312 354.789062 371.566406 C 353.527344 371.691406 352.265625 371.753906 350.996094 371.753906 C 349.730469 371.753906 348.464844 371.691406 347.207031 371.566406 C 345.945312 371.445312 344.691406 371.257812 343.449219 371.011719 C 342.207031 370.761719 340.980469 370.457031 339.765625 370.089844 C 338.554688 369.71875 337.363281 369.292969 336.191406 368.808594 C 335.023438 368.324219 333.878906 367.78125 332.761719 367.1875 C 331.644531 366.589844 330.558594 365.9375 329.503906 365.234375 C 328.449219 364.53125 327.433594 363.777344 326.453125 362.972656 C 325.476562 362.167969 324.535156 361.320312 323.640625 360.421875 C 322.746094 359.527344 321.894531 358.589844 321.089844 357.609375 C 320.289062 356.628906 319.535156 355.613281 318.828125 354.558594 C 318.125 353.507812 317.476562 352.421875 316.878906 351.304688 C 316.28125 350.1875 315.738281 349.042969 315.253906 347.871094 C 314.769531 346.699219 314.34375 345.507812 313.976562 344.296875 C 313.609375 343.085938 313.300781 341.855469 313.054688 340.613281 C 312.804688 339.371094 312.621094 338.121094 312.496094 336.859375 C 312.371094 335.597656 312.308594 334.332031 312.308594 333.066406 C 312.308594 331.800781 312.371094 330.535156 312.496094 329.273438 C 312.621094 328.011719 312.804688 326.761719 313.054688 325.519531 C 313.300781 324.277344 313.609375 323.046875 313.976562 321.835938 C 314.34375 320.625 314.769531 319.433594 315.253906 318.261719 C 315.738281 317.089844 316.28125 315.945312 316.878906 314.828125 C 317.476562 313.710938 318.125 312.625 318.828125 311.574219 C 319.535156 310.519531 320.289062 309.503906 321.089844 308.523438 C 321.894531 307.542969 322.746094 306.605469 323.640625 305.710938 C 324.535156 304.8125 325.476562 303.964844 326.453125 303.160156 C 327.433594 302.355469 328.449219 301.601562 329.503906 300.898438 C 330.558594 300.195312 331.644531 299.542969 332.761719 298.945312 C 333.878906 298.347656 335.023438 297.808594 336.191406 297.324219 C 337.363281 296.839844 338.554688 296.414062 339.765625 296.042969 C 340.980469 295.675781 342.207031 295.367188 343.449219 295.121094 C 344.691406 294.875 345.945312 294.6875 347.207031 294.566406 C 348.464844 294.441406 349.730469 294.378906 350.996094 294.378906 C 352.265625 294.378906 353.527344 294.441406 354.789062 294.566406 C 356.050781 294.6875 357.300781 294.875 358.546875 295.121094 C 359.789062 295.367188 361.015625 295.675781 362.226562 296.042969 C 363.441406 296.414062 364.632812 296.839844 365.800781 297.324219 C 366.972656 297.808594 368.117188 298.347656 369.234375 298.945312 C 370.351562 299.542969 371.4375 300.195312 372.492188 300.898438 C 373.542969 301.601562 374.5625 302.355469 375.539062 303.160156 C 376.519531 303.964844 377.457031 304.8125 378.355469 305.710938 C 379.25 306.605469 380.101562 307.542969 380.902344 308.523438 C 381.707031 309.503906 382.460938 310.519531 383.164062 311.574219 C 383.867188 312.625 384.519531 313.710938 385.117188 314.828125 C 385.714844 315.945312 386.253906 317.089844 386.742188 318.261719 C 387.226562 319.433594 387.652344 320.625 388.019531 321.835938 C 388.386719 323.046875 388.695312 324.277344 388.941406 325.519531 C 389.1875 326.761719 389.375 328.011719 389.5 329.273438 C 389.625 330.535156 389.683594 331.800781 389.683594 333.066406 Z M 389.683594 333.066406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7db7fc6df6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 326.644531 308.714844 L 375.734375 308.714844 L 375.734375 357.800781 L 326.644531 357.800781 Z M 326.644531 308.714844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7c4d5cd0e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 375.34375 333.0625 C 375.34375 333.859375 375.304688 334.65625 375.226562 335.449219 C 375.148438 336.242188 375.03125 337.03125 374.875 337.8125 C 374.71875 338.597656 374.527344 339.367188 374.296875 340.132812 C 374.0625 340.894531 373.796875 341.644531 373.492188 342.382812 C 373.183594 343.117188 372.84375 343.839844 372.46875 344.542969 C 372.09375 345.246094 371.683594 345.929688 371.238281 346.589844 C 370.796875 347.253906 370.324219 347.894531 369.816406 348.511719 C 369.3125 349.128906 368.777344 349.71875 368.210938 350.28125 C 367.648438 350.84375 367.058594 351.378906 366.441406 351.886719 C 365.824219 352.390625 365.183594 352.867188 364.523438 353.308594 C 363.859375 353.753906 363.175781 354.160156 362.472656 354.539062 C 361.769531 354.914062 361.050781 355.253906 360.3125 355.558594 C 359.574219 355.863281 358.824219 356.132812 358.0625 356.363281 C 357.300781 356.59375 356.527344 356.789062 355.746094 356.945312 C 354.964844 357.101562 354.175781 357.21875 353.382812 357.296875 C 352.589844 357.375 351.792969 357.414062 350.996094 357.414062 C 350.199219 357.414062 349.402344 357.375 348.609375 357.296875 C 347.816406 357.21875 347.027344 357.101562 346.246094 356.945312 C 345.460938 356.789062 344.691406 356.59375 343.925781 356.363281 C 343.164062 356.132812 342.414062 355.863281 341.675781 355.558594 C 340.941406 355.253906 340.21875 354.914062 339.515625 354.539062 C 338.8125 354.160156 338.128906 353.753906 337.46875 353.308594 C 336.804688 352.867188 336.164062 352.390625 335.546875 351.886719 C 334.933594 351.378906 334.339844 350.84375 333.777344 350.28125 C 333.214844 349.71875 332.679688 349.128906 332.171875 348.511719 C 331.667969 347.894531 331.191406 347.253906 330.75 346.589844 C 330.304688 345.929688 329.898438 345.246094 329.519531 344.542969 C 329.144531 343.839844 328.804688 343.117188 328.5 342.382812 C 328.195312 341.644531 327.925781 340.894531 327.695312 340.132812 C 327.464844 339.367188 327.269531 338.597656 327.113281 337.8125 C 326.957031 337.03125 326.839844 336.242188 326.761719 335.449219 C 326.683594 334.65625 326.644531 333.859375 326.644531 333.0625 C 326.644531 332.265625 326.683594 331.472656 326.761719 330.675781 C 326.839844 329.882812 326.957031 329.097656 327.113281 328.3125 C 327.269531 327.53125 327.464844 326.757812 327.695312 325.996094 C 327.925781 325.234375 328.195312 324.484375 328.5 323.746094 C 328.804688 323.007812 329.144531 322.289062 329.519531 321.585938 C 329.898438 320.882812 330.304688 320.199219 330.75 319.535156 C 331.191406 318.875 331.667969 318.234375 332.171875 317.617188 C 332.679688 317 333.214844 316.410156 333.777344 315.847656 C 334.339844 315.28125 334.933594 314.746094 335.546875 314.242188 C 336.164062 313.734375 336.804688 313.261719 337.46875 312.820312 C 338.128906 312.375 338.8125 311.964844 339.515625 311.589844 C 340.21875 311.214844 340.941406 310.875 341.675781 310.570312 C 342.414062 310.261719 343.164062 309.996094 343.925781 309.761719 C 344.691406 309.53125 345.460938 309.339844 346.246094 309.183594 C 347.027344 309.027344 347.816406 308.910156 348.609375 308.832031 C 349.402344 308.753906 350.199219 308.714844 350.996094 308.714844 C 351.792969 308.714844 352.589844 308.753906 353.382812 308.832031 C 354.175781 308.910156 354.964844 309.027344 355.746094 309.183594 C 356.527344 309.339844 357.300781 309.53125 358.0625 309.761719 C 358.824219 309.996094 359.574219 310.261719 360.3125 310.570312 C 361.050781 310.875 361.769531 311.214844 362.472656 311.589844 C 363.175781 311.964844 363.859375 312.375 364.523438 312.820312 C 365.183594 313.261719 365.824219 313.734375 366.441406 314.242188 C 367.058594 314.746094 367.648438 315.28125 368.210938 315.847656 C 368.777344 316.410156 369.3125 317 369.816406 317.617188 C 370.324219 318.234375 370.796875 318.875 371.238281 319.535156 C 371.683594 320.199219 372.09375 320.882812 372.46875 321.585938 C 372.84375 322.289062 373.183594 323.007812 373.492188 323.746094 C 373.796875 324.484375 374.0625 325.234375 374.296875 325.996094 C 374.527344 326.757812 374.71875 327.53125 374.875 328.3125 C 375.03125 329.097656 375.148438 329.882812 375.226562 330.675781 C 375.304688 331.472656 375.34375 332.265625 375.34375 333.0625 Z M 375.34375 333.0625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2.98615e-7,
    gradientTransform: "matrix(48.697702, 0, 0, 48.697702, 326.646049, 308.714947)",
    y1: 2.95687e-7,
    x2: 1.004902,
    gradientUnits: "userSpaceOnUse",
    y2: 0.99505,
    id: "6a8ccd4db5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.749329%, 65.098572%, 99.998474%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.665405%, 64.915466%, 99.795532%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.583008%, 64.732361%, 99.594116%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.499084%, 64.549255%, 99.391174%)",
    offset: 0.0117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.416687%, 64.36615%, 99.188232%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.332764%, 64.183044%, 98.985291%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.250366%, 63.999939%, 98.782349%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.166443%, 63.816833%, 98.579407%)",
    offset: 0.0273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.08252%, 63.633728%, 98.376465%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.998596%, 63.450623%, 98.173523%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.916199%, 63.267517%, 97.970581%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.832275%, 63.084412%, 97.767639%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.749878%, 62.901306%, 97.564697%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.665955%, 62.718201%, 97.361755%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.583557%, 62.535095%, 97.158813%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.499634%, 62.35199%, 96.955872%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.417236%, 62.168884%, 96.75293%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.333313%, 61.985779%, 96.549988%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.250916%, 61.802673%, 96.348572%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.166992%, 61.619568%, 96.14563%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.084595%, 61.436462%, 95.942688%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.000671%, 61.253357%, 95.739746%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.916748%, 61.070251%, 95.536804%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.832825%, 60.88562%, 95.333862%)",
    offset: 0.0898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.750427%, 60.702515%, 95.13092%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.666504%, 60.519409%, 94.927979%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.584106%, 60.336304%, 94.725037%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.500183%, 60.153198%, 94.522095%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.417786%, 59.970093%, 94.319153%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.333862%, 59.786987%, 94.116211%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.251465%, 59.603882%, 93.913269%)",
    offset: 0.117187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.167542%, 59.420776%, 93.710327%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.085144%, 59.237671%, 93.507385%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.001221%, 59.054565%, 93.304443%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.918823%, 58.87146%, 93.103027%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.8349%, 58.688354%, 92.900085%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.750977%, 58.505249%, 92.697144%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.667053%, 58.322144%, 92.494202%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.584656%, 58.139038%, 92.29126%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.500732%, 57.955933%, 92.088318%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.418335%, 57.772827%, 91.885376%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.334412%, 57.589722%, 91.682434%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.252014%, 57.406616%, 91.479492%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.168091%, 57.223511%, 91.27655%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.085693%, 57.040405%, 91.073608%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.00177%, 56.8573%, 90.870667%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.919373%, 56.674194%, 90.667725%)",
    offset: 0.179687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.835449%, 56.491089%, 90.464783%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.753052%, 56.307983%, 90.261841%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.669128%, 56.123352%, 90.058899%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.586731%, 55.940247%, 89.855957%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.502808%, 55.757141%, 89.653015%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.418884%, 55.574036%, 89.451599%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.334961%, 55.39093%, 89.248657%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.252563%, 55.207825%, 89.045715%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.16864%, 55.024719%, 88.842773%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.086243%, 54.841614%, 88.639832%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.002319%, 54.658508%, 88.43689%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.919922%, 54.475403%, 88.233948%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.835999%, 54.292297%, 88.031006%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.753601%, 54.109192%, 87.828064%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.669678%, 53.926086%, 87.625122%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.58728%, 53.742981%, 87.42218%)",
    offset: 0.242187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.503357%, 53.559875%, 87.219238%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.420959%, 53.37677%, 87.016296%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.337036%, 53.193665%, 86.813354%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.253113%, 53.010559%, 86.610413%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.169189%, 52.827454%, 86.407471%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.086792%, 52.644348%, 86.206055%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.002869%, 52.461243%, 86.003113%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.920471%, 52.278137%, 85.800171%)",
    offset: 0.273437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.836548%, 52.095032%, 85.597229%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.75415%, 51.911926%, 85.394287%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.670227%, 51.728821%, 85.191345%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.58783%, 51.545715%, 84.988403%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.503906%, 51.361084%, 84.785461%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.421509%, 51.177979%, 84.58252%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.337585%, 50.994873%, 84.379578%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.255188%, 50.811768%, 84.176636%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.171265%, 50.628662%, 83.973694%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.088867%, 50.445557%, 83.770752%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.004944%, 50.262451%, 83.56781%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.921021%, 50.079346%, 83.364868%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.837097%, 49.89624%, 83.161926%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.7547%, 49.713135%, 82.958984%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.670776%, 49.530029%, 82.756042%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.588379%, 49.346924%, 82.554626%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.504456%, 49.163818%, 82.351685%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.422058%, 48.980713%, 82.148743%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.338135%, 48.797607%, 81.945801%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.255737%, 48.614502%, 81.742859%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.171814%, 48.431396%, 81.539917%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.089417%, 48.248291%, 81.336975%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.005493%, 48.065186%, 81.134033%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.923096%, 47.88208%, 80.931091%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.839172%, 47.698975%, 80.728149%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.755249%, 47.515869%, 80.525208%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.671326%, 47.332764%, 80.322266%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.588928%, 47.149658%, 80.119324%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.505005%, 46.966553%, 79.916382%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.422607%, 46.783447%, 79.71344%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.338684%, 46.598816%, 79.510498%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.256287%, 46.41571%, 79.309082%)",
    offset: 0.398437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.172363%, 46.232605%, 79.10614%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.089966%, 46.0495%, 78.903198%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.006042%, 45.866394%, 78.700256%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.923645%, 45.683289%, 78.497314%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.839722%, 45.500183%, 78.294373%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.757324%, 45.317078%, 78.091431%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.673401%, 45.133972%, 77.888489%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.589478%, 44.950867%, 77.685547%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.505554%, 44.767761%, 77.482605%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.423157%, 44.584656%, 77.279663%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.339233%, 44.40155%, 77.076721%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.256836%, 44.218445%, 76.873779%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.172913%, 44.035339%, 76.670837%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.090515%, 43.852234%, 76.467896%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.006592%, 43.669128%, 76.264954%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.924194%, 43.486023%, 76.062012%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.840271%, 43.302917%, 75.85907%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.757874%, 43.119812%, 75.657654%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.67395%, 42.936707%, 75.454712%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.591553%, 42.753601%, 75.25177%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.507629%, 42.570496%, 75.048828%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.425232%, 42.38739%, 74.845886%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.341309%, 42.204285%, 74.642944%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.257385%, 42.021179%, 74.440002%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.173462%, 41.836548%, 74.237061%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.091064%, 41.653442%, 74.034119%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.007141%, 41.470337%, 73.831177%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.924744%, 41.287231%, 73.628235%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.84082%, 41.104126%, 73.425293%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.758423%, 40.921021%, 73.222351%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.6745%, 40.737915%, 73.019409%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.592102%, 40.55481%, 72.816467%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.371704%, 72.613525%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.425781%, 40.188599%, 72.412109%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.341858%, 40.005493%, 72.209167%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.25946%, 39.822388%, 72.006226%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.175537%, 39.639282%, 71.803284%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.091614%, 39.456177%, 71.600342%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.00769%, 39.273071%, 71.3974%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.925293%, 39.089966%, 71.194458%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.84137%, 38.90686%, 70.991516%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.758972%, 38.723755%, 70.788574%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.675049%, 38.540649%, 70.585632%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.592651%, 38.357544%, 70.38269%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.508728%, 38.174438%, 70.179749%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.426331%, 37.991333%, 69.976807%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.342407%, 37.808228%, 69.773865%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.26001%, 37.625122%, 69.570923%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.176086%, 37.442017%, 69.367981%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.093689%, 37.258911%, 69.166565%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.009766%, 37.07428%, 68.963623%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.927368%, 36.891174%, 68.760681%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.843445%, 36.708069%, 68.557739%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.759521%, 36.524963%, 68.354797%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.675598%, 36.341858%, 68.151855%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.593201%, 36.158752%, 67.948914%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.509277%, 35.975647%, 67.745972%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.42688%, 35.792542%, 67.54303%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.342957%, 35.609436%, 67.340088%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.260559%, 35.426331%, 67.137146%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.176636%, 35.243225%, 66.934204%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.094238%, 35.06012%, 66.731262%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.010315%, 34.877014%, 66.52832%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.927917%, 34.693909%, 66.325378%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.843994%, 34.510803%, 66.122437%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.761597%, 34.327698%, 65.919495%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.677673%, 34.144592%, 65.716553%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.59375%, 33.961487%, 65.515137%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.509827%, 33.778381%, 65.312195%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.427429%, 33.595276%, 65.109253%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.343506%, 33.41217%, 64.906311%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.261108%, 33.229065%, 64.703369%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.177185%, 33.045959%, 64.500427%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.094788%, 32.862854%, 64.297485%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.010864%, 32.679749%, 64.094543%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.928467%, 32.496643%, 63.891602%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.844543%, 32.312012%, 63.68866%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.762146%, 32.128906%, 63.485718%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.678223%, 31.945801%, 63.282776%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.595825%, 31.762695%, 63.079834%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.511902%, 31.57959%, 62.876892%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.427979%, 31.396484%, 62.67395%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.344055%, 31.213379%, 62.471008%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.261658%, 31.030273%, 62.269592%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.177734%, 30.847168%, 62.06665%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.095337%, 30.664062%, 61.863708%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.011414%, 30.480957%, 61.660767%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.929016%, 30.297852%, 61.457825%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.845093%, 30.114746%, 61.254883%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.762695%, 29.931641%, 61.051941%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.678772%, 29.748535%, 60.848999%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.596375%, 29.56543%, 60.646057%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.512451%, 29.382324%, 60.443115%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.430054%, 29.199219%, 60.240173%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.34613%, 29.016113%, 60.037231%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.263733%, 28.833008%, 59.83429%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.17981%, 28.649902%, 59.631348%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.095886%, 28.466797%, 59.428406%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.011963%, 28.283691%, 59.225464%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.929565%, 28.100586%, 59.022522%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.845642%, 27.91748%, 58.81958%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.763245%, 27.734375%, 58.618164%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.679321%, 27.549744%, 58.415222%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.596924%, 27.366638%, 58.21228%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.513%, 27.183533%, 58.009338%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.430603%, 27.000427%, 57.806396%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.34668%, 26.817322%, 57.603455%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.264282%, 26.634216%, 57.400513%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.180359%, 26.451111%, 57.197571%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.097961%, 26.268005%, 56.994629%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.014038%, 26.0849%, 56.791687%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.930115%, 25.901794%, 56.588745%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.846191%, 25.718689%, 56.385803%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.763794%, 25.535583%, 56.182861%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.679871%, 25.352478%, 55.979919%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.597473%, 25.169373%, 55.776978%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.51355%, 24.986267%, 55.574036%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.431152%, 24.803162%, 55.37262%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.347229%, 24.620056%, 55.169678%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.264832%, 24.436951%, 54.966736%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.180908%, 24.253845%, 54.763794%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.098511%, 24.07074%, 54.560852%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.014587%, 23.887634%, 54.35791%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.93219%, 23.704529%, 54.154968%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.848267%, 23.521423%, 53.952026%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.765869%, 23.338318%, 53.749084%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.681946%, 23.155212%, 53.546143%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.598022%, 22.972107%, 53.343201%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.514099%, 22.787476%, 53.140259%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.431702%, 22.60437%, 52.937317%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.347778%, 22.421265%, 52.734375%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.265381%, 22.238159%, 52.531433%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.181458%, 22.055054%, 52.328491%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.09906%, 21.871948%, 52.125549%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.015137%, 21.688843%, 51.922607%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.932739%, 21.505737%, 51.721191%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.848816%, 21.322632%, 51.51825%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.766418%, 21.139526%, 51.315308%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.682495%, 20.956421%, 51.112366%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.600098%, 20.773315%, 50.909424%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.516174%, 20.59021%, 50.706482%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.432251%, 20.407104%, 50.50354%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.348328%, 20.223999%, 50.300598%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.26593%, 20.040894%, 50.097656%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.182007%, 19.857788%, 49.894714%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.099609%, 19.674683%, 49.691772%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.015686%, 19.491577%, 49.488831%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.933289%, 19.308472%, 49.285889%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.849365%, 19.125366%, 49.082947%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.766968%, 18.942261%, 48.880005%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.683044%, 18.759155%, 48.677063%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.600647%, 18.57605%, 48.475647%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.516724%, 18.392944%, 48.272705%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.434326%, 18.209839%, 48.069763%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e54ba1b316"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 512.578125 322.496094 L 542.832031 322.496094 L 542.832031 330.25 L 512.578125 330.25 Z M 512.578125 322.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44b5d75379"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 512.578125 326.375 C 512.578125 325.347656 512.988281 324.359375 513.714844 323.632812 C 514.441406 322.90625 515.425781 322.496094 516.457031 322.496094 L 538.941406 322.496094 C 539.972656 322.496094 540.957031 322.90625 541.683594 323.632812 C 542.410156 324.359375 542.820312 325.347656 542.820312 326.375 C 542.820312 327.402344 542.410156 328.386719 541.683594 329.113281 C 540.957031 329.84375 539.972656 330.25 538.941406 330.25 L 516.457031 330.25 C 515.425781 330.25 514.441406 329.84375 513.714844 329.113281 C 512.988281 328.386719 512.578125 327.402344 512.578125 326.375 Z M 512.578125 326.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "546bee38f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.578125 0.496094 L 30.820312 0.496094 L 30.820312 8.25 L 0.578125 8.25 Z M 0.578125 0.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f8fd8f71b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.578125 4.375 C 0.578125 3.347656 0.988281 2.359375 1.714844 1.632812 C 2.441406 0.90625 3.425781 0.496094 4.457031 0.496094 L 26.941406 0.496094 C 27.972656 0.496094 28.957031 0.90625 29.683594 1.632812 C 30.410156 2.359375 30.820312 3.347656 30.820312 4.375 C 30.820312 5.402344 30.410156 6.386719 29.683594 7.113281 C 28.957031 7.84375 27.972656 8.25 26.941406 8.25 L 4.457031 8.25 C 3.425781 8.25 2.441406 7.84375 1.714844 7.113281 C 0.988281 6.386719 0.578125 5.402344 0.578125 4.375 Z M 0.578125 4.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 7.27596e-12,
    gradientTransform: "matrix(0.0000000000528541, -0.0302832, 0.0302832, 0.0000000000528541, 0.57933, 8.250462)",
    y1: 499.28799,
    x2: 255.999676,
    gradientUnits: "userSpaceOnUse",
    y2: 499.28799,
    id: "3e50c4c847"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.327759%, 58.691406%, 92.799377%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.205688%, 58.436584%, 92.520142%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.082092%, 58.183289%, 92.240906%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.960022%, 57.928467%, 91.963196%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.837952%, 57.673645%, 91.68396%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.715881%, 57.420349%, 91.404724%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.592285%, 57.165527%, 91.127014%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.470215%, 56.912231%, 90.847778%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.348145%, 56.65741%, 90.568542%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.224548%, 56.402588%, 90.289307%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 56.149292%, 90.011597%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.980408%, 55.89447%, 89.732361%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.858337%, 55.639648%, 89.453125%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 55.386353%, 89.173889%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.612671%, 55.131531%, 88.896179%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.490601%, 54.876709%, 88.616943%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.36853%, 54.623413%, 88.337708%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.244934%, 54.368591%, 88.058472%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.122864%, 54.11377%, 87.780762%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.000793%, 53.860474%, 87.501526%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.877197%, 53.605652%, 87.22229%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.755127%, 53.35083%, 86.94458%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.633057%, 53.097534%, 86.665344%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 52.842712%, 86.386108%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.38739%, 52.587891%, 86.106873%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.26532%, 52.334595%, 85.829163%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 52.079773%, 85.549927%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.019653%, 51.824951%, 85.270691%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.897583%, 51.571655%, 84.991455%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.775513%, 51.316833%, 84.713745%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 51.062012%, 84.434509%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.529846%, 50.808716%, 84.155273%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.407776%, 50.553894%, 83.876038%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.285706%, 50.299072%, 83.598328%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.162109%, 50.045776%, 83.319092%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.040039%, 49.790955%, 83.039856%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.917969%, 49.537659%, 82.762146%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.795898%, 49.282837%, 82.48291%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.672302%, 49.028015%, 82.203674%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.774719%, 81.924438%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.428162%, 48.519897%, 81.646729%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.304565%, 48.265076%, 81.367493%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.182495%, 48.01178%, 81.088257%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 47.756958%, 80.809021%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.938354%, 47.502136%, 80.531311%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 47.24884%, 80.252075%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.692688%, 46.994019%, 79.972839%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.570618%, 46.739197%, 79.693604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.447021%, 46.485901%, 79.415894%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.324951%, 46.231079%, 79.136658%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.202881%, 45.976257%, 78.857422%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.080811%, 45.722961%, 78.579712%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.957214%, 45.46814%, 78.300476%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.835144%, 45.213318%, 78.02124%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.713074%, 44.960022%, 77.742004%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 44.7052%, 77.464294%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.467407%, 44.450378%, 77.185059%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.345337%, 44.197083%, 76.905823%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.223267%, 43.942261%, 76.626587%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.09967%, 43.687439%, 76.348877%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.9776%, 43.434143%, 76.069641%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.85553%, 43.179321%, 75.790405%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.733459%, 42.9245%, 75.512695%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.609863%, 42.671204%, 75.233459%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.487793%, 42.416382%, 74.954224%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.365723%, 42.16156%, 74.674988%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.242126%, 41.908264%, 74.397278%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.120056%, 41.653442%, 74.118042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.997986%, 41.400146%, 73.838806%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.875916%, 41.145325%, 73.55957%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.752319%, 40.890503%, 73.28186%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.630249%, 40.637207%, 73.002625%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.382385%, 72.723389%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 40.127563%, 72.444153%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.262512%, 39.874268%, 72.166443%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.140442%, 39.619446%, 71.887207%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.018372%, 39.364624%, 71.607971%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.894775%, 39.111328%, 71.330261%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.772705%, 38.856506%, 71.051025%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.650635%, 38.601685%, 70.77179%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.527039%, 38.348389%, 70.492554%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.404968%, 38.093567%, 70.214844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.282898%, 37.838745%, 69.935608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.160828%, 37.585449%, 69.656372%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.037231%, 37.330627%, 69.377136%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.915161%, 37.075806%, 69.099426%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.793091%, 36.82251%, 68.82019%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.671021%, 36.567688%, 68.540955%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.312866%, 68.261719%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.425354%, 36.05957%, 67.984009%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.303284%, 35.804749%, 67.704773%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.179688%, 35.549927%, 67.425537%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.057617%, 35.296631%, 67.147827%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.935547%, 35.041809%, 66.868591%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.786987%, 66.589355%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.68988%, 34.533691%, 66.31012%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 34.27887%, 66.03241%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.44574%, 34.025574%, 65.753174%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.322144%, 33.770752%, 65.473938%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.200073%, 33.51593%, 65.194702%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.078003%, 33.262634%, 64.916992%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.955933%, 33.007812%, 64.637756%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.832336%, 32.752991%, 64.358521%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.710266%, 32.499695%, 64.079285%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.588196%, 32.244873%, 63.801575%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.4646%, 31.990051%, 63.522339%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.342529%, 31.736755%, 63.243103%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.220459%, 31.481934%, 62.965393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.098389%, 31.227112%, 62.686157%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.974792%, 30.973816%, 62.406921%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.852722%, 30.718994%, 62.127686%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.730652%, 30.464172%, 61.849976%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.607056%, 30.210876%, 61.57074%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.484985%, 29.956055%, 61.291504%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.362915%, 29.701233%, 61.012268%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 29.447937%, 60.734558%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.117249%, 29.193115%, 60.455322%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.995178%, 28.938293%, 60.176086%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.873108%, 28.684998%, 59.896851%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.751038%, 28.430176%, 59.619141%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.627441%, 28.175354%, 59.339905%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.505371%, 27.922058%, 59.060669%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.383301%, 27.667236%, 58.782959%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.259705%, 27.412415%, 58.503723%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.137634%, 27.159119%, 58.224487%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 26.904297%, 57.945251%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.893494%, 26.649475%, 57.667542%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.769897%, 26.396179%, 57.388306%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6ec260ab9d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 31,
    y: 0,
    height: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1fb81e8887"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.082031 318.621094 L 189.335938 318.621094 L 189.335938 326.375 L 159.082031 326.375 Z M 159.082031 318.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b796a5805"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 159.082031 322.496094 C 159.082031 321.46875 159.492188 320.484375 160.21875 319.757812 C 160.945312 319.03125 161.933594 318.621094 162.960938 318.621094 L 185.449219 318.621094 C 186.476562 318.621094 187.460938 319.03125 188.1875 319.757812 C 188.914062 320.484375 189.324219 321.46875 189.324219 322.496094 C 189.324219 323.527344 188.914062 324.511719 188.1875 325.238281 C 187.460938 325.964844 186.476562 326.375 185.449219 326.375 L 162.960938 326.375 C 161.933594 326.375 160.945312 325.964844 160.21875 325.238281 C 159.492188 324.511719 159.082031 323.527344 159.082031 322.496094 Z M 159.082031 322.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f7a6841d59"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 0.621094 L 30.324219 0.621094 L 30.324219 8.375 L 0.0820312 8.375 Z M 0.0820312 0.621094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d847aa2f2a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0820312 4.496094 C 0.0820312 3.46875 0.492188 2.484375 1.21875 1.757812 C 1.945312 1.03125 2.933594 0.621094 3.960938 0.621094 L 26.449219 0.621094 C 27.476562 0.621094 28.460938 1.03125 29.1875 1.757812 C 29.914062 2.484375 30.324219 3.46875 30.324219 4.496094 C 30.324219 5.527344 29.914062 6.511719 29.1875 7.238281 C 28.460938 7.964844 27.476562 8.375 26.449219 8.375 L 3.960938 8.375 C 2.933594 8.375 1.945312 7.964844 1.21875 7.238281 C 0.492188 6.511719 0.0820312 5.527344 0.0820312 4.496094 Z M 0.0820312 4.496094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.0000317008,
    gradientTransform: "matrix(0.0000000000528541, -0.0302832, 0.0302832, 0.0000000000528541, 0.0832984, 8.374193)",
    y1: 499.28799,
    x2: 255.999732,
    gradientUnits: "userSpaceOnUse",
    y2: 499.28799,
    id: "41e6f86dd0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.327759%, 58.691406%, 92.799377%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.205688%, 58.436584%, 92.520142%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.082092%, 58.183289%, 92.240906%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.960022%, 57.928467%, 91.963196%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.837952%, 57.673645%, 91.68396%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.715881%, 57.420349%, 91.404724%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.592285%, 57.165527%, 91.127014%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.470215%, 56.912231%, 90.847778%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.348145%, 56.65741%, 90.568542%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.224548%, 56.402588%, 90.289307%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 56.149292%, 90.011597%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.980408%, 55.89447%, 89.732361%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.858337%, 55.639648%, 89.453125%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 55.386353%, 89.173889%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.612671%, 55.131531%, 88.896179%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.490601%, 54.876709%, 88.616943%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.36853%, 54.623413%, 88.337708%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.244934%, 54.368591%, 88.058472%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.122864%, 54.11377%, 87.780762%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.000793%, 53.860474%, 87.501526%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.877197%, 53.605652%, 87.22229%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.755127%, 53.35083%, 86.94458%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.633057%, 53.097534%, 86.665344%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 52.842712%, 86.386108%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.38739%, 52.587891%, 86.106873%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.26532%, 52.334595%, 85.829163%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 52.079773%, 85.549927%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.019653%, 51.824951%, 85.270691%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.897583%, 51.571655%, 84.991455%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.775513%, 51.316833%, 84.713745%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 51.062012%, 84.434509%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.529846%, 50.808716%, 84.155273%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.407776%, 50.553894%, 83.876038%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.285706%, 50.299072%, 83.598328%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.162109%, 50.045776%, 83.319092%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.040039%, 49.790955%, 83.039856%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.917969%, 49.537659%, 82.762146%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.795898%, 49.282837%, 82.48291%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.672302%, 49.028015%, 82.203674%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.774719%, 81.924438%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.428162%, 48.519897%, 81.646729%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.304565%, 48.265076%, 81.367493%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.182495%, 48.01178%, 81.088257%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 47.756958%, 80.809021%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.938354%, 47.502136%, 80.531311%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 47.24884%, 80.252075%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.692688%, 46.994019%, 79.972839%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.570618%, 46.739197%, 79.693604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.447021%, 46.485901%, 79.415894%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.324951%, 46.231079%, 79.136658%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.202881%, 45.976257%, 78.857422%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.080811%, 45.722961%, 78.579712%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.957214%, 45.46814%, 78.300476%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.835144%, 45.213318%, 78.02124%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.713074%, 44.960022%, 77.742004%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 44.7052%, 77.464294%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.467407%, 44.450378%, 77.185059%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.345337%, 44.197083%, 76.905823%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.223267%, 43.942261%, 76.626587%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.09967%, 43.687439%, 76.348877%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.9776%, 43.434143%, 76.069641%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.85553%, 43.179321%, 75.790405%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.733459%, 42.9245%, 75.512695%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.609863%, 42.671204%, 75.233459%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.487793%, 42.416382%, 74.954224%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.365723%, 42.16156%, 74.674988%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.242126%, 41.908264%, 74.397278%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.120056%, 41.653442%, 74.118042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.997986%, 41.400146%, 73.838806%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.875916%, 41.145325%, 73.55957%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.752319%, 40.890503%, 73.28186%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.630249%, 40.637207%, 73.002625%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.382385%, 72.723389%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 40.127563%, 72.444153%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.262512%, 39.874268%, 72.166443%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.140442%, 39.619446%, 71.887207%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.018372%, 39.364624%, 71.607971%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.894775%, 39.111328%, 71.330261%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.772705%, 38.856506%, 71.051025%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.650635%, 38.601685%, 70.77179%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.527039%, 38.348389%, 70.492554%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.404968%, 38.093567%, 70.214844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.282898%, 37.838745%, 69.935608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.160828%, 37.585449%, 69.656372%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.037231%, 37.330627%, 69.377136%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.915161%, 37.075806%, 69.099426%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.793091%, 36.82251%, 68.82019%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.671021%, 36.567688%, 68.540955%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.312866%, 68.261719%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.425354%, 36.05957%, 67.984009%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.303284%, 35.804749%, 67.704773%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.179688%, 35.549927%, 67.425537%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.057617%, 35.296631%, 67.147827%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.935547%, 35.041809%, 66.868591%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.786987%, 66.589355%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.68988%, 34.533691%, 66.31012%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 34.27887%, 66.03241%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.44574%, 34.025574%, 65.753174%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.322144%, 33.770752%, 65.473938%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.200073%, 33.51593%, 65.194702%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.078003%, 33.262634%, 64.916992%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.955933%, 33.007812%, 64.637756%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.832336%, 32.752991%, 64.358521%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.710266%, 32.499695%, 64.079285%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.588196%, 32.244873%, 63.801575%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.4646%, 31.990051%, 63.522339%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.342529%, 31.736755%, 63.243103%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.220459%, 31.481934%, 62.965393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.098389%, 31.227112%, 62.686157%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.974792%, 30.973816%, 62.406921%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.852722%, 30.718994%, 62.127686%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.730652%, 30.464172%, 61.849976%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.607056%, 30.210876%, 61.57074%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.484985%, 29.956055%, 61.291504%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.362915%, 29.701233%, 61.012268%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 29.447937%, 60.734558%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.117249%, 29.193115%, 60.455322%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.995178%, 28.938293%, 60.176086%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.873108%, 28.684998%, 59.896851%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.751038%, 28.430176%, 59.619141%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.627441%, 28.175354%, 59.339905%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.505371%, 27.922058%, 59.060669%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.383301%, 27.667236%, 58.782959%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.259705%, 27.412415%, 58.503723%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.137634%, 27.159119%, 58.224487%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 26.904297%, 57.945251%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.893494%, 26.649475%, 57.667542%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.769897%, 26.396179%, 57.388306%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d00848ca82"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 31,
    y: 0,
    height: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb3ba62511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.246094 99.3125 L 584.75 99.3125 L 584.75 566.816406 L 117.246094 566.816406 Z M 117.246094 99.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e910b82e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 350.996094 99.3125 C 221.898438 99.3125 117.246094 203.96875 117.246094 333.066406 C 117.246094 462.164062 221.898438 566.816406 350.996094 566.816406 C 480.09375 566.816406 584.75 462.164062 584.75 333.066406 C 584.75 203.96875 480.09375 99.3125 350.996094 99.3125 Z M 350.996094 99.3125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3.553e-15,
    gradientTransform: "matrix(8.779785, 0, 0, 8.779785, -0.000000000000028422, 0.000000000000028422)",
    y1: 32,
    x2: 63.999999,
    gradientUnits: "userSpaceOnUse",
    y2: 32,
    id: "0d21af77d2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.388794%, 58.81958%, 92.939758%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.327759%, 58.691406%, 92.799377%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.205688%, 58.436584%, 92.520142%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.082092%, 58.183289%, 92.240906%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.960022%, 57.928467%, 91.963196%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.837952%, 57.673645%, 91.68396%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.715881%, 57.420349%, 91.404724%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.592285%, 57.165527%, 91.127014%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.470215%, 56.912231%, 90.847778%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.348145%, 56.65741%, 90.568542%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.224548%, 56.402588%, 90.289307%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.102478%, 56.149292%, 90.011597%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.980408%, 55.89447%, 89.732361%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.858337%, 55.639648%, 89.453125%)",
    offset: 0.101563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.734741%, 55.386353%, 89.173889%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.612671%, 55.131531%, 88.896179%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.490601%, 54.876709%, 88.616943%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.36853%, 54.623413%, 88.337708%)",
    offset: 0.132813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.244934%, 54.368591%, 88.058472%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.122864%, 54.11377%, 87.780762%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.000793%, 53.860474%, 87.501526%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.877197%, 53.605652%, 87.22229%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.755127%, 53.35083%, 86.94458%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.633057%, 53.097534%, 86.665344%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.510986%, 52.842712%, 86.386108%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.38739%, 52.587891%, 86.106873%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.26532%, 52.334595%, 85.829163%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.14325%, 52.079773%, 85.549927%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.019653%, 51.824951%, 85.270691%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.897583%, 51.571655%, 84.991455%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.775513%, 51.316833%, 84.713745%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.653442%, 51.062012%, 84.434509%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.529846%, 50.808716%, 84.155273%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.407776%, 50.553894%, 83.876038%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.285706%, 50.299072%, 83.598328%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.162109%, 50.045776%, 83.319092%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.040039%, 49.790955%, 83.039856%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.917969%, 49.537659%, 82.762146%)",
    offset: 0.289063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.795898%, 49.282837%, 82.48291%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.672302%, 49.028015%, 82.203674%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.550232%, 48.774719%, 81.924438%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.428162%, 48.519897%, 81.646729%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.304565%, 48.265076%, 81.367493%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.182495%, 48.01178%, 81.088257%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.060425%, 47.756958%, 80.809021%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.938354%, 47.502136%, 80.531311%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.814758%, 47.24884%, 80.252075%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.692688%, 46.994019%, 79.972839%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.570618%, 46.739197%, 79.693604%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.447021%, 46.485901%, 79.415894%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.324951%, 46.231079%, 79.136658%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.202881%, 45.976257%, 78.857422%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.080811%, 45.722961%, 78.579712%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.957214%, 45.46814%, 78.300476%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.835144%, 45.213318%, 78.02124%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.713074%, 44.960022%, 77.742004%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.591003%, 44.7052%, 77.464294%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.467407%, 44.450378%, 77.185059%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.345337%, 44.197083%, 76.905823%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.223267%, 43.942261%, 76.626587%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.09967%, 43.687439%, 76.348877%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.9776%, 43.434143%, 76.069641%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.85553%, 43.179321%, 75.790405%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.733459%, 42.9245%, 75.511169%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.609863%, 42.671204%, 75.233459%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.487793%, 42.416382%, 74.954224%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.365723%, 42.16156%, 74.674988%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.242126%, 41.908264%, 74.397278%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.120056%, 41.653442%, 74.118042%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.997986%, 41.400146%, 73.838806%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.875916%, 41.145325%, 73.55957%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.752319%, 40.890503%, 73.28186%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.630249%, 40.637207%, 73.002625%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.508179%, 40.382385%, 72.723389%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.384583%, 40.127563%, 72.444153%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.262512%, 39.874268%, 72.166443%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.140442%, 39.619446%, 71.887207%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.018372%, 39.364624%, 71.607971%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.894775%, 39.111328%, 71.330261%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.772705%, 38.856506%, 71.051025%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.650635%, 38.601685%, 70.77179%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.527039%, 38.348389%, 70.492554%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.404968%, 38.093567%, 70.214844%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.282898%, 37.838745%, 69.935608%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.160828%, 37.585449%, 69.656372%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.037231%, 37.330627%, 69.377136%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.915161%, 37.075806%, 69.099426%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.793091%, 36.82251%, 68.82019%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.671021%, 36.567688%, 68.540955%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.547424%, 36.312866%, 68.261719%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.425354%, 36.05957%, 67.984009%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.303284%, 35.804749%, 67.704773%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.179688%, 35.549927%, 67.425537%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.057617%, 35.296631%, 67.147827%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.935547%, 35.041809%, 66.868591%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.813477%, 34.786987%, 66.589355%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.68988%, 34.533691%, 66.31012%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.56781%, 34.27887%, 66.03241%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.44574%, 34.024048%, 65.753174%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.322144%, 33.770752%, 65.473938%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.200073%, 33.51593%, 65.194702%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.078003%, 33.262634%, 64.916992%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.955933%, 33.007812%, 64.637756%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.832336%, 32.752991%, 64.358521%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.710266%, 32.499695%, 64.079285%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.588196%, 32.244873%, 63.801575%)",
    offset: 0.820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.4646%, 31.990051%, 63.522339%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.342529%, 31.736755%, 63.243103%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.220459%, 31.481934%, 62.965393%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.098389%, 31.227112%, 62.686157%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.974792%, 30.973816%, 62.406921%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.852722%, 30.718994%, 62.127686%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.730652%, 30.464172%, 61.849976%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.607056%, 30.210876%, 61.57074%)",
    offset: 0.882813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.484985%, 29.956055%, 61.291504%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.362915%, 29.701233%, 61.012268%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 29.447937%, 60.734558%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.117249%, 29.193115%, 60.455322%)",
    offset: 0.914063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.995178%, 28.938293%, 60.176086%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.873108%, 28.684998%, 59.896851%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.749512%, 28.430176%, 59.619141%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.627441%, 28.175354%, 59.339905%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.505371%, 27.922058%, 59.060669%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.383301%, 27.667236%, 58.782959%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.259705%, 27.412415%, 58.503723%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.137634%, 27.159119%, 58.224487%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.015564%, 26.904297%, 57.945251%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.893494%, 26.649475%, 57.667542%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.769897%, 26.396179%, 57.388306%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb64aeffd9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 702,
    y: 0,
    height: 684
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#ffffff",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -81,
    width: 972,
    fill: "#ffffff",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 88, 623)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85fe2da4aa)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.445623, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 15.671875 -52.46875 L 15.671875 0 Z M 5.46875 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.576078, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.671875 -33.625 L 15.671875 0 L 5.46875 0 L 5.46875 -52.46875 L 13.375 -52.46875 L 40.71875 -18.03125 L 40.71875 -52.390625 L 50.90625 -52.390625 L 50.90625 0 L 42.640625 0 Z M 15.671875 -33.625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.948601, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 36.71875 -38.71875 C 36.375 -39.0625 35.742188 -39.53125 34.828125 -40.125 C 33.921875 -40.71875 32.816406 -41.296875 31.515625 -41.859375 C 30.210938 -42.421875 28.796875 -42.898438 27.265625 -43.296875 C 25.734375 -43.691406 24.179688 -43.890625 22.609375 -43.890625 C 19.804688 -43.890625 17.710938 -43.367188 16.328125 -42.328125 C 14.953125 -41.296875 14.265625 -39.847656 14.265625 -37.984375 C 14.265625 -36.898438 14.519531 -36 15.03125 -35.28125 C 15.550781 -34.570312 16.300781 -33.941406 17.28125 -33.390625 C 18.269531 -32.847656 19.515625 -32.351562 21.015625 -31.90625 C 22.523438 -31.46875 24.265625 -31.003906 26.234375 -30.515625 C 28.796875 -29.828125 31.125 -29.085938 33.21875 -28.296875 C 35.3125 -27.515625 37.082031 -26.53125 38.53125 -25.34375 C 39.988281 -24.164062 41.109375 -22.75 41.890625 -21.09375 C 42.679688 -19.445312 43.078125 -17.414062 43.078125 -15 C 43.078125 -12.1875 42.546875 -9.78125 41.484375 -7.78125 C 40.429688 -5.789062 39.003906 -4.179688 37.203125 -2.953125 C 35.398438 -1.722656 33.328125 -0.820312 30.984375 -0.25 C 28.648438 0.3125 26.203125 0.59375 23.640625 0.59375 C 19.703125 0.59375 15.8125 0.00390625 11.96875 -1.171875 C 8.125 -2.359375 4.675781 -4.035156 1.625 -6.203125 L 6.140625 -15 C 6.578125 -14.550781 7.375 -13.96875 8.53125 -13.25 C 9.6875 -12.539062 11.050781 -11.828125 12.625 -11.109375 C 14.207031 -10.398438 15.957031 -9.800781 17.875 -9.3125 C 19.800781 -8.820312 21.773438 -8.578125 23.796875 -8.578125 C 29.410156 -8.578125 32.21875 -10.375 32.21875 -13.96875 C 32.21875 -15.101562 31.894531 -16.0625 31.25 -16.84375 C 30.613281 -17.632812 29.703125 -18.320312 28.515625 -18.90625 C 27.335938 -19.5 25.910156 -20.039062 24.234375 -20.53125 C 22.554688 -21.03125 20.6875 -21.578125 18.625 -22.171875 C 16.113281 -22.859375 13.929688 -23.609375 12.078125 -24.421875 C 10.234375 -25.234375 8.691406 -26.191406 7.453125 -27.296875 C 6.222656 -28.410156 5.300781 -29.691406 4.6875 -31.140625 C 4.070312 -32.597656 3.765625 -34.335938 3.765625 -36.359375 C 3.765625 -39.015625 4.253906 -41.375 5.234375 -43.4375 C 6.222656 -45.507812 7.59375 -47.234375 9.34375 -48.609375 C 11.09375 -49.992188 13.125 -51.039062 15.4375 -51.75 C 17.757812 -52.46875 20.25 -52.828125 22.90625 -52.828125 C 26.601562 -52.828125 30.003906 -52.25 33.109375 -51.09375 C 36.210938 -49.9375 38.921875 -48.570312 41.234375 -47 Z M 36.71875 -38.71875 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.238713, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 27.703125 -52.46875 C 30.117188 -52.46875 32.347656 -51.960938 34.390625 -50.953125 C 36.441406 -49.941406 38.203125 -48.609375 39.671875 -46.953125 C 41.148438 -45.304688 42.304688 -43.4375 43.140625 -41.34375 C 43.984375 -39.25 44.40625 -37.144531 44.40625 -35.03125 C 44.40625 -32.8125 44.007812 -30.65625 43.21875 -28.5625 C 42.4375 -26.46875 41.332031 -24.609375 39.90625 -22.984375 C 38.476562 -21.359375 36.753906 -20.050781 34.734375 -19.0625 C 32.710938 -18.082031 30.492188 -17.59375 28.078125 -17.59375 L 15.671875 -17.59375 L 15.671875 0 Z M 15.671875 -26.53125 L 27.484375 -26.53125 C 29.359375 -26.53125 30.921875 -27.289062 32.171875 -28.8125 C 33.429688 -30.34375 34.0625 -32.414062 34.0625 -35.03125 C 34.0625 -36.351562 33.863281 -37.546875 33.46875 -38.609375 C 33.070312 -39.671875 32.550781 -40.566406 31.90625 -41.296875 C 31.269531 -42.035156 30.519531 -42.585938 29.65625 -42.953125 C 28.800781 -43.328125 27.929688 -43.515625 27.046875 -43.515625 L 15.671875 -43.515625 Z M 15.671875 -26.53125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.267651, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 15.671875 -52.46875 L 15.671875 0 Z M 5.46875 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.398106, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 28.671875 -52.46875 C 31.085938 -52.46875 33.316406 -51.960938 35.359375 -50.953125 C 37.398438 -49.941406 39.160156 -48.609375 40.640625 -46.953125 C 42.117188 -45.304688 43.273438 -43.4375 44.109375 -41.34375 C 44.953125 -39.25 45.375 -37.144531 45.375 -35.03125 C 45.375 -31.625 44.519531 -28.53125 42.8125 -25.75 C 41.113281 -22.96875 38.8125 -20.960938 35.90625 -19.734375 L 47.875 0 L 36.421875 0 L 25.71875 -17.59375 L 15.671875 -17.59375 L 15.671875 0 Z M 15.671875 -26.53125 L 28.453125 -26.53125 C 29.390625 -26.53125 30.265625 -26.75 31.078125 -27.1875 C 31.890625 -27.632812 32.585938 -28.238281 33.171875 -29 C 33.765625 -29.757812 34.234375 -30.65625 34.578125 -31.6875 C 34.921875 -32.726562 35.09375 -33.84375 35.09375 -35.03125 C 35.09375 -36.257812 34.894531 -37.390625 34.5 -38.421875 C 34.113281 -39.453125 33.585938 -40.347656 32.921875 -41.109375 C 32.253906 -41.878906 31.488281 -42.472656 30.625 -42.890625 C 29.757812 -43.304688 28.882812 -43.515625 28 -43.515625 L 15.671875 -43.515625 Z M 15.671875 -26.53125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.530116, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 27.859375 0.375 C 24.015625 0.375 20.523438 -0.375 17.390625 -1.875 C 14.265625 -3.382812 11.582031 -5.378906 9.34375 -7.859375 C 7.101562 -10.347656 5.367188 -13.191406 4.140625 -16.390625 C 2.910156 -19.597656 2.296875 -22.878906 2.296875 -26.234375 C 2.296875 -29.734375 2.945312 -33.082031 4.25 -36.28125 C 5.550781 -39.476562 7.347656 -42.304688 9.640625 -44.765625 C 11.929688 -47.234375 14.648438 -49.191406 17.796875 -50.640625 C 20.953125 -52.097656 24.378906 -52.828125 28.078125 -52.828125 C 31.867188 -52.828125 35.328125 -52.050781 38.453125 -50.5 C 41.585938 -48.945312 44.257812 -46.914062 46.46875 -44.40625 C 48.6875 -41.894531 50.410156 -39.035156 51.640625 -35.828125 C 52.878906 -32.628906 53.5 -29.378906 53.5 -26.078125 C 53.5 -22.585938 52.859375 -19.253906 51.578125 -16.078125 C 50.296875 -12.898438 48.519531 -10.085938 46.25 -7.640625 C 43.988281 -5.203125 41.28125 -3.253906 38.125 -1.796875 C 34.976562 -0.347656 31.554688 0.375 27.859375 0.375 Z M 12.640625 -26.234375 C 12.640625 -23.960938 12.984375 -21.769531 13.671875 -19.65625 C 14.359375 -17.539062 15.351562 -15.664062 16.65625 -14.03125 C 17.96875 -12.40625 19.570312 -11.097656 21.46875 -10.109375 C 23.363281 -9.128906 25.519531 -8.640625 27.9375 -8.640625 C 30.394531 -8.640625 32.570312 -9.144531 34.46875 -10.15625 C 36.363281 -11.164062 37.960938 -12.507812 39.265625 -14.1875 C 40.578125 -15.863281 41.5625 -17.75 42.21875 -19.84375 C 42.882812 -21.9375 43.21875 -24.066406 43.21875 -26.234375 C 43.21875 -28.492188 42.859375 -30.679688 42.140625 -32.796875 C 41.429688 -34.921875 40.425781 -36.796875 39.125 -38.421875 C 37.820312 -40.046875 36.222656 -41.335938 34.328125 -42.296875 C 32.429688 -43.265625 30.300781 -43.75 27.9375 -43.75 C 25.46875 -43.75 23.269531 -43.242188 21.34375 -42.234375 C 19.425781 -41.222656 17.828125 -39.890625 16.546875 -38.234375 C 15.265625 -36.585938 14.289062 -34.71875 13.625 -32.625 C 12.96875 -30.53125 12.640625 -28.398438 12.640625 -26.234375 Z M 12.640625 -26.234375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(295.385455, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 44.703125 -43.515625 L 27.9375 -43.515625 L 27.9375 0 L 17.8125 0 L 17.8125 -43.515625 L 1.03125 -43.515625 L 1.03125 -52.46875 L 44.703125 -52.46875 Z M 44.703125 -43.515625 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(341.118865, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 28.671875 -52.46875 C 31.085938 -52.46875 33.316406 -51.960938 35.359375 -50.953125 C 37.398438 -49.941406 39.160156 -48.609375 40.640625 -46.953125 C 42.117188 -45.304688 43.273438 -43.4375 44.109375 -41.34375 C 44.953125 -39.25 45.375 -37.144531 45.375 -35.03125 C 45.375 -31.625 44.519531 -28.53125 42.8125 -25.75 C 41.113281 -22.96875 38.8125 -20.960938 35.90625 -19.734375 L 47.875 0 L 36.421875 0 L 25.71875 -17.59375 L 15.671875 -17.59375 L 15.671875 0 Z M 15.671875 -26.53125 L 28.453125 -26.53125 C 29.390625 -26.53125 30.265625 -26.75 31.078125 -27.1875 C 31.890625 -27.632812 32.585938 -28.238281 33.171875 -29 C 33.765625 -29.757812 34.234375 -30.65625 34.578125 -31.6875 C 34.921875 -32.726562 35.09375 -33.84375 35.09375 -35.03125 C 35.09375 -36.257812 34.894531 -37.390625 34.5 -38.421875 C 34.113281 -39.453125 33.585938 -40.347656 32.921875 -41.109375 C 32.253906 -41.878906 31.488281 -42.472656 30.625 -42.890625 C 29.757812 -43.304688 28.882812 -43.515625 28 -43.515625 L 15.671875 -43.515625 Z M 15.671875 -26.53125 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(390.250861, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 20.390625 -52.46875 L 29.40625 -52.46875 L 49.359375 0 L 38.859375 0 L 33.984375 -13.078125 L 15.671875 -13.078125 L 10.859375 0 L 0.375 0 Z M 32.140625 -20.25 L 24.90625 -40.859375 L 17.359375 -20.25 Z M 32.140625 -20.25 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(439.900084, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.296875 -26.59375 C 2.296875 -29.800781 2.875 -32.96875 4.03125 -36.09375 C 5.1875 -39.21875 6.867188 -42.007812 9.078125 -44.46875 C 11.296875 -46.9375 14.003906 -48.9375 17.203125 -50.46875 C 20.410156 -52 24.0625 -52.765625 28.15625 -52.765625 C 32.976562 -52.765625 37.148438 -51.703125 40.671875 -49.578125 C 44.191406 -47.460938 46.816406 -44.707031 48.546875 -41.3125 L 40.71875 -35.90625 C 40.019531 -37.382812 39.175781 -38.628906 38.1875 -39.640625 C 37.207031 -40.648438 36.148438 -41.453125 35.015625 -42.046875 C 33.890625 -42.640625 32.707031 -43.070312 31.46875 -43.34375 C 30.238281 -43.613281 29.035156 -43.75 27.859375 -43.75 C 25.296875 -43.75 23.066406 -43.226562 21.171875 -42.1875 C 19.273438 -41.15625 17.695312 -39.8125 16.4375 -38.15625 C 15.1875 -36.507812 14.238281 -34.640625 13.59375 -32.546875 C 12.957031 -30.453125 12.640625 -28.375 12.640625 -26.3125 C 12.640625 -23.988281 13.007812 -21.753906 13.75 -19.609375 C 14.488281 -17.472656 15.535156 -15.59375 16.890625 -13.96875 C 18.242188 -12.34375 19.867188 -11.035156 21.765625 -10.046875 C 23.660156 -9.066406 25.738281 -8.578125 28 -8.578125 C 29.1875 -8.578125 30.421875 -8.722656 31.703125 -9.015625 C 32.984375 -9.304688 34.203125 -9.769531 35.359375 -10.40625 C 36.515625 -11.050781 37.582031 -11.878906 38.5625 -12.890625 C 39.550781 -13.898438 40.34375 -15.117188 40.9375 -16.546875 L 49.28125 -11.75 C 48.445312 -9.78125 47.253906 -8.039062 45.703125 -6.53125 C 44.148438 -5.03125 42.398438 -3.765625 40.453125 -2.734375 C 38.503906 -1.703125 36.421875 -0.914062 34.203125 -0.375 C 31.992188 0.164062 29.828125 0.4375 27.703125 0.4375 C 23.960938 0.4375 20.539062 -0.347656 17.4375 -1.921875 C 14.332031 -3.492188 11.660156 -5.546875 9.421875 -8.078125 C 7.179688 -10.617188 5.429688 -13.503906 4.171875 -16.734375 C 2.921875 -19.960938 2.296875 -23.25 2.296875 -26.59375 Z M 2.296875 -26.59375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(490.583588, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.390625 L 15.671875 -52.390625 L 15.671875 -27.484375 L 37.6875 -52.46875 L 48.921875 -52.46875 L 28.8125 -29.1875 L 50.171875 0 L 38.71875 0 L 22.390625 -22.6875 L 15.671875 -15.671875 L 15.671875 0 Z M 5.46875 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(540.011155, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 41.890625 -8.9375 L 41.890625 0 L 5.46875 0 L 5.46875 -52.46875 L 41.234375 -52.46875 L 41.234375 -43.515625 L 15.671875 -43.515625 L 15.671875 -30.890625 L 37.765625 -30.890625 L 37.765625 -22.609375 L 15.671875 -22.609375 L 15.671875 -8.9375 Z M 41.890625 -8.9375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#008afc",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(584.414685, 68.554255)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5.46875 0 L 5.46875 -52.46875 L 28.671875 -52.46875 C 31.085938 -52.46875 33.316406 -51.960938 35.359375 -50.953125 C 37.398438 -49.941406 39.160156 -48.609375 40.640625 -46.953125 C 42.117188 -45.304688 43.273438 -43.4375 44.109375 -41.34375 C 44.953125 -39.25 45.375 -37.144531 45.375 -35.03125 C 45.375 -31.625 44.519531 -28.53125 42.8125 -25.75 C 41.113281 -22.96875 38.8125 -20.960938 35.90625 -19.734375 L 47.875 0 L 36.421875 0 L 25.71875 -17.59375 L 15.671875 -17.59375 L 15.671875 0 Z M 15.671875 -26.53125 L 28.453125 -26.53125 C 29.390625 -26.53125 30.265625 -26.75 31.078125 -27.1875 C 31.890625 -27.632812 32.585938 -28.238281 33.171875 -29 C 33.765625 -29.757812 34.234375 -30.65625 34.578125 -31.6875 C 34.921875 -32.726562 35.09375 -33.84375 35.09375 -35.03125 C 35.09375 -36.257812 34.894531 -37.390625 34.5 -38.421875 C 34.113281 -39.453125 33.585938 -40.347656 32.921875 -41.109375 C 32.253906 -41.878906 31.488281 -42.472656 30.625 -42.890625 C 29.757812 -43.304688 28.882812 -43.515625 28 -43.515625 L 15.671875 -43.515625 Z M 15.671875 -26.53125 "
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#74bf5a7795)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e97f9cccfc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 401, 139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8852956c6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#80788ecf13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#195f1f997d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b951779ffe)",
    d: "M 0.125 0.871094 L 0.125 31.113281 L 7.875 31.113281 L 7.875 0.871094 Z M 0.125 0.871094 ",
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 54, 0.000000000000039746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb64aeffd9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd476f986b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#983c23e251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 329, 363)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d60e29ca45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c9f7b209a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#487d66dc5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f0d7f98cec)",
    d: "M 0.332031 0.5625 L 0.332031 197.386719 L 43.667969 197.386719 L 43.667969 0.5625 Z M 0.332031 0.5625 ",
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5227c8171d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa0d651ce1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aeee68e06b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 372, 250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#148dd309cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cbf5a6eb66)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4fa8f46064)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a4fdaf9d7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5b4d603b7a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44195688a0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5fb67b1be6)",
    d: "M 102.734375 -44.707031 L -28.105469 12.351562 L 19.660156 121.871094 L 150.496094 64.808594 Z M 102.734375 -44.707031 ",
    fillRule: "nonzero"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad5c6e4169)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab1c562f37)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8bd1843ce1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 208, 253)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea282670ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f1bfee2dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#425ffdfd79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b962268f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c8f69834d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#387cc681ce)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#95b5ecd7c8)",
    d: "M 148.945312 12.109375 L 19.046875 -44.460938 L -28.320312 64.308594 L 101.574219 120.878906 Z M 148.945312 12.109375 ",
    fillRule: "nonzero"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0abdf30515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a794e42c0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 312.308594 294.378906 L 312.308594 371.753906 L 389.683594 371.753906 L 389.683594 294.378906 Z M 312.308594 294.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7db7fc6df6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7c4d5cd0e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#6a8ccd4db5)",
    d: "M 326.644531 308.714844 L 326.644531 357.414062 L 375.34375 357.414062 L 375.34375 308.714844 Z M 326.644531 308.714844 ",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e54ba1b316)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44b5d75379)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 512, 322)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ec260ab9d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#546bee38f3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f8fd8f71b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#3e50c4c847)",
    d: "M 0.578125 8.25 L 30.820312 8.25 L 30.820312 0.496094 L 0.578125 0.496094 Z M 0.578125 8.25 ",
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1fb81e8887)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b796a5805)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 159, 318)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d00848ca82)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f7a6841d59)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d847aa2f2a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#41e6f86dd0)",
    d: "M 0.0820312 8.375 L 30.324219 8.375 L 30.324219 0.621094 L 0.0820312 0.621094 Z M 0.0820312 8.375 ",
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb3ba62511)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e910b82e9)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.831995, 0, 0, 0.831995, 117.245035, 99.313894)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 280.952505 -0.00167574 C 125.786107 -0.00167574 0.00127268 125.787853 0.00127268 280.954252 C 0.00127268 436.12065 125.786107 561.905484 280.952505 561.905484 C 436.118904 561.905484 561.908433 436.12065 561.908433 280.954252 C 561.908433 125.787853 436.118904 -0.00167574 280.952505 -0.00167574 Z M 280.952505 -0.00167574 ",
    stroke: "url(#0d21af77d2)",
    strokeWidth: 66.707138,
    strokeMiterlimit: 4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72d0206a27660a5c231fe1d73b87c0ec.svg";
export { ForwardRef as ReactComponent };